<template>
  <div class="">
    <app-loading class="date-selector" :loading="!images">
      <app-sel
        v-model="date"
        @input="changeDate"
        :items="dates"
        key-name="id"
        label-name="label"
        :label="$ml.get('Select date')"
        v-if="dates"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            v-for="item in items"
            :value="item"
            :key="item.id"
          >
            {{ item.label }}
          </app-sel-opt>
        </template>
      </app-sel>


      <!-- {{image}} -->
      <a class="btn h-btn app-btn default size-normal download-image" :href="image" v-if="image" download="" >
        <div class="content">{{$ml.get('Download selected image')}}</div>
      </a>

    </app-loading>

  </div>

</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      date: null,
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      dates: 'satellite/dates',
      images: 'satellite/images',
      image: 'satellite/image',
    }),
  },
  beforeDestroy() {
    this.$store.commit('satellite/setImageURL', null);
  },
  created() {
    // this.date = 0;
    if(this.dates.length && this.date) {
      // this.date = this.dates.length - 1;
      this.changeDate();
    }
    // if(this.defaultDate) {
    //   this.date = this.defaultDate;
    // }
  },
  methods: {
    changeDate() {
      this.$store.dispatch('satellite/selectDate', this.dates.find(x => x.id == this.date).value);
      this.$store.dispatch('satellite/selectImage').then(res => {
        this.$emit('renderSatelliteImage');
      });
    },
  }

}
</script>

<style lang="scss" scoped>
.date-selector {
  margin-bottom: 24px;
  // margin-top: 12px;
  padding-top: 16px;
  .download-image {
    margin-top: 16px;
  }
  .app-sel {
    &::v-deep {
      .scroller {
        display: flex;
        flex-direction: column-reverse;
      }
    }
  }
}
</style>
